var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqEquipments = function SvgFaqEquipments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-equipments_svg__a)",
    d: "M22.132 7.265a2.82 2.82 0 0 0-2.119-.216c-.709.216-1.295.699-1.665 1.388l-1.553 3.105-.39-.987c-.196-.473-.69-.72-1.152-.566a1 1 0 0 0-.576.504.9.9 0 0 0-.02.71l.39.977-2.941-1.347a2.39 2.39 0 0 0-2.89.72l-4.072 5.336-.4.514a2.66 2.66 0 0 0 .555 3.723c1.141.843 2.879.586 3.732-.566l2.808-3.794a.5.5 0 0 1 .627-.165l4.35 1.913c.257.113.534.175.812.195l1.12 2.828a.937.937 0 0 0 1.152.566.98.98 0 0 0 .566-.504.9.9 0 0 0 .02-.71l-1.11-2.807a2.4 2.4 0 0 0 .504-.648l3.373-6.406a2.786 2.786 0 0 0-1.142-3.774zm-8.905 7.62a2.38 2.38 0 0 0-2.88.76l-2.59 3.496-.227.319a.804.804 0 0 1-1.12.164.794.794 0 0 1-.186-1.1l4.463-5.84a.51.51 0 0 1 .627-.155l4.71 2.15.699 1.758-3.506-1.543zm8.4-4.731-3.074 5.82-.843-2.128 2.139-4.227.154-.339a.92.92 0 0 1 1.244-.37.92.92 0 0 1 .38 1.244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-equipments_svg__b)",
    d: "M24.27.643a3.054 3.054 0 1 0 .002 6.108A3.054 3.054 0 0 0 24.27.643m0 4.575a1.514 1.514 0 0 1-1.51-1.511c0-.833.678-1.512 1.51-1.512.834 0 1.512.679 1.512 1.512s-.678 1.511-1.511 1.511"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-equipments_svg__c)",
    d: "M2.666 19.275a1.035 1.035 0 0 0-1.327-.597 1.035 1.035 0 0 0-.596 1.327l1.038 2.694a1.02 1.02 0 0 0 1.327.586c.535-.205.792-.802.596-1.326l-1.038-2.694z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-equipments_svg__d)",
    d: "M5.289 9.527A4.34 4.34 0 1 1 5.29.847a4.34 4.34 0 0 1-.001 8.68m0-7.136a2.8 2.8 0 0 0-2.797 2.797 2.8 2.8 0 0 0 2.797 2.797 2.8 2.8 0 0 0 2.797-2.797A2.8 2.8 0 0 0 5.289 2.39",
    opacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-equipments_svg__a",
    x1: 13.903,
    x2: 13.903,
    y1: 22.144,
    y2: 6.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-equipments_svg__b",
    x1: 24.271,
    x2: 24.271,
    y1: 6.751,
    y2: 0.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-equipments_svg__c",
    x1: 2.224,
    x2: 2.224,
    y1: 23.357,
    y2: 18.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-equipments_svg__d",
    x1: 5.289,
    x2: 5.289,
    y1: 9.527,
    y2: 0.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgFaqEquipments;